import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { LimitedTimeEvent, LimitedTimeEventType } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { SharedModule } from '@app/shared/shared.module';
import { EventManager } from '@app/shared/utils/event-manager';
import { Observable } from 'rxjs';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-limited-time-events-layout',
  templateUrl: './limited-time-events-layout.component.html',
  styleUrls: ['./limited-time-events-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SharedModule],
})
export class LimitedTimeEventsLayoutComponent {
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);

  @Input() event: LimitedTimeEvent;
  @Input() modalName: NonPersistedModalName;
  @Input() infoModal: NonPersistedModalName;
  @Input() showCloseButton = true;
  @Input() showInfoButton = true;

  LimitedTimeEventType = LimitedTimeEventType;

  componentDestroy: () => Observable<unknown>;

  openInfo(): void {
    this.eventManager.openModal(new Modal(this.infoModal, ModalType.View, this.event));
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.modalName, ModalType.View, this.event));
  }
}
